import styled, { css } from 'styled-components';
import { Label } from '../label/label.component.js';

const buttonStyles = () => css `
  margin: 2px 8px 0 0;
  height: 16px;
  width: 16px;
`;
const Input = styled.input `
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  ${buttonStyles}
`;
const errorStyles = (props) => props.error &&
    props.checked &&
    css `
    border: 1px solid ${props.theme.colors.content.error};
  `;
const getFocusColor = (color) => color === 'primary' ? 'primary' : 'primaryInverse';
const checkedStyles = (props) => props.checked &&
    css `
    border: 1px solid ${props.theme.colors.background.primaryInverse};
    box-shadow: inset 0 0 0 5px ${props.theme.colors.background.primaryInverse};
    ${buttonStyles} :focus-within {
      box-shadow: inset 0 0 0 5px
          ${props.theme.colors.background.primaryInverse},
        0 0 0 2px ${props.theme.colors.background[getFocusColor(props.color)]},
        0 0 0 4px ${props.theme.colors.background.primaryInverse};
    }
  `;
const highlightStyles = (props) => props.checked &&
    props.highlightSelected &&
    css `
    background-color: ${props.theme.colors.background.secondary};
    width: 100%;
    border-radius: 4px;
  `;
const RadioButton = styled.span `
  background-color: transparent;
  border: 1px solid ${props => props.theme.colors.background.controls};
  border-radius: 50%;
  flex-shrink: 0;
  position: relative;
  ${buttonStyles} :focus-within {
    outline: transparent solid 2px;
    box-shadow: ${props => `0 0 0 2px ${props.theme.colors.background[getFocusColor(props.color)]}, 0 0 0 4px ${props.theme.colors.background.primaryInverse}`};
  }
  ${checkedStyles}
  ${errorStyles}
`;
const RadioLabel = styled(Label) `
  align-items: flex-start;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  &:hover {
    span {
      border-color: ${props => !props.disabled && props.theme.colors.background.primaryInverse};
    }
  }
  ${highlightStyles}
`;
const TextWrapper = styled.div `
  display: flex;
  flex-direction: column;
`;

export { Input, RadioButton, RadioLabel, TextWrapper };
